// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getABtestFromState } from '../../../../../utils';
import { fetchBreadCrumbs } from '../../CategoryListingPage/container/CategoryListingPage.selectors';

export const getNavTree = (state) => {
  return state.Navigation.navigationData;
};

export const prodDetails = (state) => {
  return state.BundleProduct;
};

export const getOldBreadCrumbs = (state) => {
  return state.BundleProduct && state.BundleProduct.breadCrumbs;
};

const getIsFromCategoryPage = (_, query) => {
  return query?.referer === 'categoryPage';
};

export const getBreadCrumbs = createSelector(
  getOldBreadCrumbs,
  fetchBreadCrumbs,
  getIsFromCategoryPage,
  (oldBreadCrumbs, newBreadCrumbs, isFromCategoryPage) => {
    if (isFromCategoryPage) return newBreadCrumbs;
    const breadCrumbsData = oldBreadCrumbs;
    const homeBreadCrumb = {
      destination: 'c',
      displayName: 'Home',
      pathSuffix: 'home',
    };
    if (breadCrumbsData) {
      const filteredBreadcrumbArray = breadCrumbsData.filter((item) => {
        return item.displayName === 'Home';
      });
      const isHomeBreadCrumbAvailable =
        filteredBreadcrumbArray && filteredBreadcrumbArray.length > 0;
      if (!isHomeBreadCrumbAvailable) {
        breadCrumbsData.unshift(homeBreadCrumb);
      }
    }
    return breadCrumbsData;
  }
);

export const getAlternateSizes = (state) => {
  return state.BundleProduct.currentProduct && state.BundleProduct.currentProduct.alternateSizes;
};

export const getDescription = (state) => {
  return state.BundleProduct.currentProduct && state.BundleProduct.currentProduct.longDescription;
};

export const getRatingsProductId = (state) => {
  return state.BundleProduct.currentProduct && state.BundleProduct.currentProduct.ratingsProductId;
};

export const getGeneralProductId = (state) => {
  return state.BundleProduct.currentProduct && state.BundleProduct.currentProduct.generalProductId;
};

export const getShortDescription = (state) => {
  return state.BundleProduct.currentProduct && state.BundleProduct.currentProduct.shortDescription;
};

// TODO - This is temporary - fix it by introducing the image carousel and zoom
export const getDefaultImage = (state) => {
  const firstColor =
    state.BundleProduct.currentProduct &&
    state.BundleProduct.currentProduct.colorFitsSizesMap &&
    state.BundleProduct.currentProduct.colorFitsSizesMap[0].color.name;
  return (
    firstColor &&
    state.BundleProduct.currentProduct &&
    state.BundleProduct.currentProduct.imagesByColor[firstColor].basicImageUrl
  );
};

export const getCurrentCurrency = (state) => {
  return state.session.siteDetails.currency;
};

export const getCurrencyAttributes = (state) => {
  return (
    (state.session.siteDetails && state.session.siteDetails.currencyAttributes) || {
      exchangevalue: 1,
      merchantMargin: 1,
      roundMethod: '',
    }
  );
};

export const getCurrentProduct = (state) => {
  return state.BundleProduct && state.BundleProduct.currentProduct;
};

export const getCurrentBundle = (state) => {
  return state.BundleProduct && state.BundleProduct.currentBundle;
};

export const getDepartmentBundleProducts = createSelector(prodDetails, (bundleProduct) => {
  return bundleProduct?.departmentBundleProducts;
});

export const getAddedToBagErrorCatId = (state) => {
  return state.AddedToBagReducer && state?.AddedToBagReducer?.get('errorCatId');
};

export const getLoadingState = (state) => {
  return state.BundleProduct && state.BundleProduct.isLoading;
};

export const getOnModelImageAbTestBundlePdp = (state) => {
  return getABtestFromState(state.AbTest).enableOnModelImageOnBundlePDP;
};

export const getPageUrl = (state) => {
  return state.BundleProduct.pageUrl;
};

export const getSlpData = (state) => {
  return state && state?.SearchListingPage && state?.SearchListingPage?.loadedProductsPages;
};

export const getInYourBagProducts = createSelector(prodDetails, (bundleProduct) => {
  return bundleProduct?.inYourBagData;
});

export const getIsBundle = createSelector(prodDetails, (bundleProduct) => {
  return bundleProduct?.isBundle;
});

export const getCarryForwardImgUrl = (state) => {
  return state?.BundleProduct?.carryForwardImgUrl;
};

export const selectFormNamesOfPjPlanner = createSelector(
  prodDetails,
  (bundleProduct) => bundleProduct?.formName
);
